import { render, staticRenderFns } from "./QuestionTypeList.vue?vue&type=template&id=6a3a658a&"
import script from "./QuestionTypeList.vue?vue&type=script&lang=ts&"
export * from "./QuestionTypeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a3a658a')) {
      api.createRecord('6a3a658a', component.options)
    } else {
      api.reload('6a3a658a', component.options)
    }
    module.hot.accept("./QuestionTypeList.vue?vue&type=template&id=6a3a658a&", function () {
      api.rerender('6a3a658a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/questionType/QuestionTypeList.vue"
export default component.exports